/* RESPONSIBLE TEAM: team-frontend-tech */
import { A } from '@ember/array';
const STATUS_CODES = {
  NOTPRESENT: 0,
  VALID: 1,
  STALE: 2,
  EXPIRED: 3,
};

const ERROR_CODES = {
  UNKNOWN_ERROR: 0,
  QUOTA_EXCEEDED: 1,
};

let generateCacheKey = function (namespace, modelName, id) {
  return A([namespace, modelName, id]).compact().join('::');
};

export { STATUS_CODES, ERROR_CODES, generateCacheKey };
